<app-header-style-two></app-header-style-two>

<div class="page-title-area">
    <div class="container">
        <h1>Contact Us</h1>
    </div>
</div>

<div class="main-content-area">
    <div class="container">
        <div class="contact-wrapper">
            <!-- Contact Information Card -->
            <div class="contact-info-section">
                <div class="contact-card">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="bx bx-map"></i>
                            Get In Touch
                        </h3>
                    </div>
                    <div class="contact-content">
                        <p>We're here to help you start driving. Reach out to us through any of the methods below.</p>

                        <div class="info-items">
                            <div class="info-item">
                                <div class="icon-wrapper"><i class="bx bx-phone-call"></i></div>
                                <div class="info-details">
                                    <h4>Call Us</h4>
                                    <!-- <a href="tel:718-799-1350">(718) 799-1350</a> -->
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="icon-wrapper"><i class="bx bx-envelope"></i></div>
                                <div class="info-details">
                                    <h4>Email Us</h4>
                                    <!-- <a href="mailto:info@lamadrivingschool.com">info@@lamadrivingschool.com</a> -->
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="icon-wrapper"><i class="bx bx-location-plus"></i></div>
                                <div class="info-details">
                                    <h4>Visit Us</h4>
                                    <!-- <span>Staten Island, NY</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contact Form Card -->
            <div class="contact-form-section">
                <div class="form-card">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="bx bx-envelope"></i>
                            Send us a Message
                        </h3>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="formGroup" (ngSubmit)="create()">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>{{"MENU.Name" | translate}}</label>
                                        <input class="form-control" formControlName="name" type="text"
                                            placeholder="{{'MENU.Name' | translate}}">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'name')">
                                            {{"MENU.Required" | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>{{"MENU.Phone" | translate}}</label>
                                        <input class="form-control" formControlName="phone" type="number"
                                            placeholder="{{'MENU.Phone' | translate}}">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'phone')">
                                            {{"MENU.Required" | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>{{"MENU.Email" | translate}}</label>
                                        <input type="email" formControlName="email" class="form-control"
                                            placeholder="{{'MENU.Email' | translate}}">
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'email')">
                                            {{"MENU.Required" | translate}}
                                        </div>
                                        <div class="invalid-feedback" *ngIf="controlHasError('email', 'email')">
                                            Please enter a valid email address
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" formControlName="message" rows="5"
                                            placeholder="How can we help you?"></textarea>
                                        <div class="invalid-feedback" *ngIf="controlHasError('required', 'message')">
                                            {{"MENU.Required" | translate}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 text-center mt-3">
                                    <button type="submit" class="submit-btn">
                                        <span>{{"MENU.Send" | translate}}</span>
                                        <i class='bx bx-paper-plane'></i>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>